
import { defineComponent, computed } from "vue";
import useAuthUserMedia from "@/composables/useAuthUserMedia";
import { trans, transChoice } from "@/globals/translator";
import Button from "@moonlight/vue3/components/Button.vue";
import ButtonText from "@moonlight/vue3/components/button/ButtonText.vue";
import ButtonIcon from "@moonlight/vue3/components/button/ButtonIcon.vue";
export default defineComponent({
  components: {
    Button,
    ButtonText,
    ButtonIcon,
  },
  props: {
    mediaId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { authUserMedia, fetchAuthUserMedia } = useAuthUserMedia();

    fetchAuthUserMedia(props.mediaId);

    const hasPercent = computed(
      () => authUserMedia.value?.keep_watching?.percent > 0
    );

    const buttonData = computed(() => {
      if (!authUserMedia.value) {
        return;
      }
      if (
        !authUserMedia.value?.consumable?.is_active ||
        !authUserMedia.value?.watch_link
      ) {
        return {
          available: false,
          icon: "visible-not",
          text: trans("general.not_available"),
        };
      }
      const seasonNumber = authUserMedia.value.keep_watching?.season_number;
      const episodeNumber = authUserMedia.value.keep_watching?.episode_number;
      if (seasonNumber && episodeNumber) {
        return {
          available: true,
          icon: "play-circle-outline",
          text: `${trans(
            hasPercent.value || seasonNumber > 1 || episodeNumber > 1
              ? "general.keep_watching"
              : "general.watch_now"
          )} T${seasonNumber} E${episodeNumber}`,
        };
      }

      return {
        available: true,
        icon: "play-circle-outline",
        text: trans(
          hasPercent.value ? "general.keep_watching" : "general.watch_now"
        ),
      };
    });

    return { authUserMedia, trans, buttonData, transChoice, hasPercent };
  },
});
